
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useAuth } from "./AuthProvider"; // Import this!
import Navbar from "./components/Navbar";
import Dashboard from "./pages/Dashboard";
import Insights from "./pages/Insights";
import Login from "./pages/Login";
import RegisterPage from "./pages/RegisterPage";
import ProtectedRoute from "./components/ProtectedRoute";
import ManageListings from "./pages/ManageListings";                // NEW
import Profile from "./pages/Profile";
import StoreSettings from "./pages/StoreSettings";
import StorePackages from "./pages/StorePackages"
import SalesOrders from "./pages/SalesOrders";
import AffiliateSettlements from "./pages/AffiliateSettlements";
import StoreSponsorships from "./pages/StoreSponsorships";
import ToastHost from "./components/ToastHost";

function AppRoutes() {
  const { user, userData, authLoading } = useAuth();
  const location = useLocation();
  const isAuthRoute =
    location.pathname === "/login" || location.pathname === "/register";

  if (authLoading) {
    return <div className="min-h-screen bg-white" />;
  }

  return (
    <>
      <ToastHost />
      {user && !isAuthRoute && <Navbar />}
      <div
        className={
          user && !isAuthRoute ? "min-h-screen pt-20 lg:pt-0 lg:pl-[288px]" : ""
        }
      >
      <Routes>
        <Route
          path="/login"
          element={user ? <Navigate to="/dashboard" replace /> : <Login />}
        />
        <Route
          path="/register"
          element={user ? <Navigate to="/dashboard" replace /> : <RegisterPage />}
        />

        {/* All protected routes below */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/insights"
          element={
            <ProtectedRoute requireActivePackage>
              <Insights />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-listing"
          element={
            <ProtectedRoute requireActivePackage>
              <ManageListings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile userData={userData} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/store"
          element={
            <ProtectedRoute requireActivePackage>
              <StoreSettings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/store-packages"
          element={
            <ProtectedRoute allowExpiredPackage>
              <StorePackages />
            </ProtectedRoute>
          }
        />
<Route
  path="/sales-orders"
  element={
    <ProtectedRoute requireActivePackage>
      <SalesOrders />
    </ProtectedRoute>
  }
/>
<Route
  path="/affiliate-settlements"
  element={
    <ProtectedRoute requireActivePackage>
      <AffiliateSettlements />
    </ProtectedRoute>
  }
/>
<Route
  path="/store-sponsorships"
  element={
    <ProtectedRoute requireActivePackage>
      <StoreSponsorships />
    </ProtectedRoute>
  }
/>

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
